import React from 'react';
import { Container, Box, Typography } from '@mui/material';
import { DashboardLayout } from '../components/DashboardLayout';
import { DevNotificationTools } from '../components/development/DevNotificationTools';

const DevPushPage: React.FC = () => {
  return (
    <DashboardLayout onChangePassword={() => {}}>
      <Container maxWidth="lg" sx={{ py: 3 }}>
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight={700} gutterBottom>
            Панель розробника Push-повідомлень
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Інструменти для налагодження та тестування Firebase Cloud Messaging (тільки для розробників).
          </Typography>
        </Box>

        <DevNotificationTools />
      </Container>
    </DashboardLayout>
  );
};

export default DevPushPage;
